const siteUrl = 'https://www.colors.tools';

const isNoIndexPath = (pathname = '/') => {
    const path = pathname.split(/[?#]/)[0].replace(/\/+$/, '').toLowerCase();
    return (
        path === '/app' ||
        path.startsWith('/app/') ||
        [
            '/signin',
            '/signup',
            '/resetpassword',
            '/recoverpassword',
            '/recoveraccount',
            '/confirmaccount',
            '/404',
            '/404.html',
            '/mailing-list',
            '/list-of-installed-packages',
        ].includes(path)
    );
};

const normalizeCanonicalPath = (pathname = '/') => {
    const path = pathname.split(/[?#]/)[0].replace(/\/{2,}/g, '/');
    const pathWithLeadingSlash = path.startsWith('/') ? path : `/${path}`;
    if (pathWithLeadingSlash === '/') return '/';
    return `${pathWithLeadingSlash.replace(/\/+$/, '')}/`;
};

const canonicalUrl = (pathname = '/') => `${siteUrl}${normalizeCanonicalPath(pathname)}`;

module.exports = { siteUrl, isNoIndexPath, normalizeCanonicalPath, canonicalUrl };
